define([
	"dojo/_base/declare",
	"dojo/when",
	"csi/_base/underscore",
	"csi/store/UserNames",
	"csi/store/Values",
	"csi/store/_ClientRequestMixin"
], function(declare,when,_,UserNames,Values,_ClientRequestMixin) {

	return declare([Values,_ClientRequestMixin], {
		/**
		 * Convert UserNames into Values items
 		 * @param {Deferred} dfd
		 */
		_resolveData: function(dfd) {
			when(UserNames.load(), function() {
				var store = UserNames.store();
				var id = store.idProperty;
				var label = store.labelProperty;

				var data = _.map(store.query(), function(item) {
					return {
						_text: item[label],
						_value: item[id]
					};
				});

				dfd.resolve(data);
			});
		}
	});
});